import React from 'react';
import { useIntl } from 'react-intl';

import Textbox from 'carbon-react/lib/components/textbox';

import { UserFormController } from '../types';

interface UserDetailsFieldsProps {
  disableIdentityFields?: boolean;
  form: UserFormController;
}

export const UserDetailsFields = ({ disableIdentityFields = false, form }: UserDetailsFieldsProps) => {
  const intl = useIntl();

  return (
    <>
      <Textbox
        autoComplete="off"
        disabled={disableIdentityFields}
        error={form.errors.fullName?.message}
        id="user-full-name"
        label={intl.formatMessage({ id: 'common.full_name', defaultMessage: 'Full name' })}
        mb={3}
        onBlur={form.revalidate}
        onChange={form.onChangeFullName}
        placeholder={intl.formatMessage({
          id: 'common.enter_full_name_here',
          defaultMessage: 'Enter full name here'
        })}
        required
        value={form.fullName}
      />
      <Textbox
        autoComplete="off"
        disabled={disableIdentityFields}
        error={form.errors.email?.message}
        id="user-email"
        label={intl.formatMessage({ id: 'common.email_address', defaultMessage: 'Email address' })}
        mb={3}
        onBlur={form.revalidate}
        onChange={form.onChangeEmail}
        placeholder={intl.formatMessage({
          id: 'common.enter_email_address_here',
          defaultMessage: 'Enter email address here'
        })}
        required
        value={form.email}
      />
    </>
  );
};
